// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eK8K","colBig":"styles_colBig__ciDEt","colSmall":"styles_colSmall__2mfOD"};